import { render, staticRenderFns } from "./all_rule.vue?vue&type=template&id=3c164d8a&"
import script from "./all_rule.vue?vue&type=script&lang=js&"
export * from "./all_rule.vue?vue&type=script&lang=js&"
import style0 from "./all_rule.vue?vue&type=style&index=0&id=3c164d8a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports